import React from "react";
import { EditorState, Modifier, convertToRaw } from "draft-js";
import Editor from "@draft-js-plugins/editor";
import createMentionPlugin from "@draft-js-plugins/mention";
import createHashtagPlugin from "@draft-js-plugins/hashtag";
import createLinkifyPlugin from "@draft-js-plugins/linkify";
import Entry from "./Components/Entry";
import Mentioned from "./Components/Mentioned";

import mentionsStyles from "./mentionsStyles.module.css";
import "@draft-js-plugins/mention/lib/plugin.css";
import "@draft-js-plugins/hashtag/lib/plugin.css";

class CommentTextBox extends React.Component {
  constructor(props) {
    super(props);

    this.isFirstLoad = true;
    this.searchTimerId = 0;
    this.editorRef = React.createRef();

    this.mentionPlugin = createMentionPlugin({
      theme: mentionsStyles,
      mentionComponent: Mentioned,
      entityMutability: "MUTABLE",
    });
    this.hashtagPlugin = createHashtagPlugin({
      hashtagComponent: (p) => (
        <a href={`/search?term=${p.decoratedText}`} target="_blank">
          {p.children}
        </a>
      ),
    });
    this.linkifyPlugin = createLinkifyPlugin();

    var editorState = EditorState.createEmpty();

    if (this.props.content) {
      editorState = EditorState.createWithContent(this.props.content);
    }

    this.state = {
      editorState: editorState,
      suggestions: this.props.suggestion.data,
      suggestionOpen: false,
    };
  }

  onSearchChange = ({ value }) => {
    clearTimeout(this.searchTimerId);
    this.searchTimerId = setTimeout(() => {
      fetch(`${this.props.suggestion.url}?term=${value}`, {
        headers: {
          Authorization: `Bearer ${this.props.suggestion.token}`,
        },
      }).then((response) => {
        if (!response.ok) return;

        response.json().then((result) => {
          this.setState({
            suggestions: result,
          });
        });
      });
    }, 500);
  };

  onChange = (editorState) => {
    this.setState({ editorState });

    if (this.props.onChange)
      this.props.onChange(convertToRaw(editorState.getCurrentContent()));
  };

  onSuggestionOpenChange = (_open) => {
    this.setState({ suggestionOpen: _open });
  };

  handlePastedText = (text, html) => {
    // we'll add a message for the offending user to the editor state
    const newContent = Modifier.insertText(
      this.state.editorState.getCurrentContent(),
      this.state.editorState.getSelection(),
      "nice try, chump!"
    );

    // update our state with the new editor content
    this.onChange(
      EditorState.push(this.state.editorState, newContent, "insert-characters")
    );
    return true;
  };

  focus = () => {
    this.editorRef.current.editor.focus();
  };

  render() {
    const { MentionSuggestions } = this.mentionPlugin;
    const plugins = [
      this.mentionPlugin,
      this.linkifyPlugin,
      this.hashtagPlugin,
    ];

    return (
      <div onClick={() => this.focus()}>
        <Editor
          editorKey={"editor"}
          editorState={this.state.editorState}
          placeholder={
            this.props.placeholder ??
            (this.props.readOnly ? "" : "Add a comment.")
          }
          readOnly={this.props.readOnly}
          onChange={this.onChange}
          handlePastedText={this.handlePastedText}
          plugins={plugins}
          ref={this.editorRef}
        />
        <MentionSuggestions
          renderEmptyPopup={true}
          open={this.state.suggestionOpen}
          onOpenChange={this.onSuggestionOpenChange}
          onSearchChange={this.onSearchChange}
          suggestions={this.state.suggestions}
          entryComponent={Entry}
          onAddMention={() => this.setState({ suggestions: [] })}
        />
      </div>
    );
  }

  componentDidUpdate() {
    if (this.isFirstLoad) {
      this.isFirstLoad = false;
      if (!this.props.readOnly) this.focus();
    }
  }
}

export default CommentTextBox;
